import { render, staticRenderFns } from "./violin.vue?vue&type=template&id=b29ef506&"
import script from "./violin.vue?vue&type=script&lang=js&"
export * from "./violin.vue?vue&type=script&lang=js&"
import style0 from "./violin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports